var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-insights",
      staticStyle: { "margin-bottom": "20px" }
    },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 5, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Conversion Rate:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h2", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.activitiesCompletedNumber))
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h5", { staticClass: "brown_line" }, [
                    _vm._v(
                      _vm._s(
                        _vm.activitiesCompletedPercentage
                          ? Math.ceil(_vm.activitiesCompletedPercentage)
                          : 0
                      ) + "%"
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Purchase Rate:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.SalesConversionRate
                          ? Math.ceil(_vm.SalesConversionRate)
                          : 0
                      ) + "%"
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("In-Store Shop:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.upsellRatio ? Math.ceil(_vm.upsellRatio) : 0) +
                        "%"
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Survey Purchase Intent:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.purchaseIntentSummaryTotal
                          ? Math.ceil(_vm.purchaseIntentSummaryTotal)
                          : 0
                      ) + "%"
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Reimbursements:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h2", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("$" + _vm._s(_vm.byMeCreditConsumed))
                  ])
                ])
              ])
            ])
          ]),
          _vm.shopIntentSummaryYes != null
            ? _c("slide", [
                _c("div", { staticClass: "metrics-box" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("h3", [_vm._v("Survey Shop Intent:")]),
                      _c("h2", [_vm._v(_vm._s(_vm.shopIntentSummaryYes))])
                    ]),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("h5", [
                        _vm._v(
                          _vm._s(
                            _vm.shopIntentSummaryTotal
                              ? Math.ceil(_vm.shopIntentSummaryTotal)
                              : 0
                          ) + "%"
                        )
                      ])
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Selfies with Product:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h2", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.totalSelfies))
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Issues:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.activitiesWithIssuesNumber))]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Repeat Locations:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h2", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.repeatLocations))
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Average Lead Response Time:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h2", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.AverageLeadResponseTime))
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }